var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.88232,
    width: 2.58825,
    height: 6.47063,
    rx: 1.29413,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6475,
    width: 2.58825,
    height: 6.47063,
    rx: 1.29413,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.353 2.58789H7.76503V5.17597C7.76503 6.60542 6.60623 7.76422 5.17678 7.76422C3.74732 7.76422 2.58852 6.60542 2.58852 5.17597V2.84404C1.07589 3.41461 0 4.8756 0 6.58789V17.9998C0 20.2089 1.79086 21.9998 4 21.9998H14.1178C16.3269 21.9998 18.1178 20.2089 18.1178 17.9998V6.58789C18.1178 4.8757 17.042 3.41476 15.5295 2.84413V5.17597C15.5295 6.60542 14.3707 7.76422 12.9412 7.76422C11.5118 7.76422 10.353 6.60542 10.353 5.17597V2.58789ZM4.15029 14.7059C3.6449 14.2005 3.6449 13.3811 4.15029 12.8757C4.65568 12.3704 5.47507 12.3704 5.98046 12.8757L7.8101 14.7054L12.3859 10.1295C12.8913 9.62416 13.7107 9.62416 14.2161 10.1295C14.7215 10.6349 14.7215 11.4543 14.2161 11.9597L8.75657 17.4193C8.7465 17.43 8.73622 17.4407 8.72572 17.4512C8.22033 17.9566 7.40093 17.9566 6.89555 17.4512L4.15029 14.7059Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.d3cd543e7b39e4776a7d2f1d90330846.svg";
export { ForwardRef as ReactComponent };